import { CSSProperties } from 'react';
import theme, { TMaterialStyles } from '../../../theme';
import leftArrow from '../../../../assets/icons/carousel-arrow-left.png';
import rightArrow from '../../../../assets/icons/carousel-arrow-right.png';

export const swiperStyle: CSSProperties = {
  width: '320px',
  maxWidth: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  height: '100%',
};

export const customNavPrev: CSSProperties = {
  left: '-73px',
  backgroundImage: `url(${leftArrow})`,
  width: '93px',
  height: '77px',
  position: 'absolute',
  zIndex: 10,
  cursor: 'pointer',
  backgroundSize: '100% 100%',
};

export const customNavNext: CSSProperties = {
  right: '-73px',
  backgroundImage: `url(${rightArrow})`,
  width: '93px',
  height: '77px',
  position: 'absolute',
  zIndex: 10,
  cursor: 'pointer',
  backgroundSize: '100% 100%',
};

export const materialStyles: TMaterialStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
    height: 'calc(100% - 130px)',
    maxHeight: '540px',
    maxWidth: '90%',
  },
  slide: {
    backgroundSize: '100% 100%',
    width: '316px',
    maxWidth: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'flex-end',
  },
  title: {
    fontSize: '30px',
    letterSpacing: '0.1px',
    fontFamily: 'Rubber Duck !important',
  },
  text: {
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '0.1px',
    lineHeight: '17px',
  },
  bottomContainer: {
    padding: '0 16px 32px',
  },
  customNav: {
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
  },
  backgroundIllustration: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: -1,
  },
  scoreContainer: {
    position: 'absolute',
    width: '180px',
    height: '38px',
    top: '16px',
    right: '14px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  scoreIcon: {
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  scoreText: {
    fontFamily: 'Rubber Duck !important',
    paddingLeft: '30px',
    fontSize: '22px',
    fontWeight: '400',
    letterSpacing: '0.1px',
    color: theme.palette.primary.main,
    position: 'relative',
    top: '-4px',
  },
  attemptsContainer: {
    position: 'absolute',
    top: '20px',
    left: '17px',
  },
  attemptsTrainingContainer: {
    position: 'absolute',
    top: '14px',
    left: '14px',
  },
};
